module.exports = __webpack_public_path__ + "img/bus-blue-outline.308f31b4.svg";